<div class="title">
  <ion-label color="dark">{{ title }}</ion-label>
</div>
